<div class="header">
    <mat-icon>group_add</mat-icon>
    <h2>Création des joueurs</h2>
</div>
<div class="widget">Joueurs créés : {{playerCount || 0}}</div>
